import React from 'react';

import {useGlobalState} from 'hooks/useGlobalState';

import {SmScreenError} from './SmErrorAndSuccess/SmScreenError';
import {SmScreenSuccess} from './SmErrorAndSuccess/SmScreenSuccess';
import './SmScreenMessages.scss';

const SmScreenMessages = () => {
  const {success, error} = useGlobalState((state) => state.app);

  return (
    <div className="small-screen-toast">
      {success && <SmScreenSuccess success={success} />}
      {error && <SmScreenError error={error} />}
    </div>
  );
};

export default SmScreenMessages;
